import axios from "axios"

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  const apiClient = axios.create({
    baseURL: config.public.axios.browserBaseURL,
    timeout: 60000,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    },
    withCredentials: true
  })

  nuxtApp.provide("axios", apiClient)
})
